import PropTypes from 'prop-types';
import {useState} from 'react';
import {Button, Checkbox, Image} from 'semantic-ui-react';
import EditableTitle from '../EditableTitle';
import SummaryNotes from '../SummaryNotes';

const AgentBio = ({
  agentPhoto,
  agentName,
  onUpdateIntroduction,
  onUpdateAgentNotes,
  reportType,
  section,
  sendEditAgentBioEvent,
  toggleAgentBio,
  updatePreferences
}) => {
  const {
    sectionData: {
      toggleProfileBlurb,
      agentIntro,
      agentNotes,
    } = {}
  } = section;

  const [profileBlurbEnabled, setProfileBlurbEnabled] = useState(
    toggleProfileBlurb !== undefined ?
      toggleProfileBlurb :
      true
  );
  const [formTitle, setFormTitle] = useState(agentIntro);
  const [formNotes, setFormNotes] = useState(agentNotes);

  const onTitleEdit = (data) => {
    setFormTitle(data.title);
  };

  const onNotesEdit = (value) => {
    setFormNotes(value);
  };

  const onToggleBlurb = (event, data) => {
    setProfileBlurbEnabled(data.checked);
    toggleAgentBio(data.checked);
  };

  const onSave = () => {
    sendEditAgentBioEvent(formTitle, formNotes);
    onUpdateIntroduction(formTitle);
    onUpdateAgentNotes(formNotes);
    updatePreferences({
      'targetProperty.sectionData.agentIntro': formTitle,
      'targetProperty.sectionData.agentNotes': formNotes,
    }, reportType);
  };

  const canSave = () => {
    return formTitle !== agentIntro ||
      formNotes !== agentNotes;
  };

  return (
    <div className="agent-bio">
      <Checkbox className="agent-blurb-toggle" label="Profile Blurb" onClick={onToggleBlurb} checked={profileBlurbEnabled}/>
      <div className="agent-container">
        {agentPhoto && (
          <Image alt={`${agentName} photo`} src={agentPhoto} disabled={!profileBlurbEnabled}/>
        )}
         <div className="agent-bio-notes">
          <EditableTitle
            placeholder={`Introducing ${agentName}`}
            title={formTitle}
            onUpdateData={onTitleEdit}
            maxLength={29}
            isEnabled={profileBlurbEnabled}
            width="50%"
          />
          <SummaryNotes
            enabled={profileBlurbEnabled}
            maxLines={7}
            value={formNotes}
            onChange={(key, value) => {
              onNotesEdit(value);
            }}
            placeholder="Enter a description about yourself"
          />
          <div className="button-bar">
            <Button primary onClick={onSave} disabled={!canSave() || !profileBlurbEnabled}>Save</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

AgentBio.propTypes = {
  agentPhoto: PropTypes.string,
  agentName: PropTypes.string.isRequired,
  onUpdateIntroduction: PropTypes.func.isRequired,
  onUpdateAgentNotes: PropTypes.func.isRequired,
  reportType: PropTypes.string.isRequired,
  section: PropTypes.object.isRequired,
  sendEditAgentBioEvent: PropTypes.func.isRequired,
  toggleAgentBio: PropTypes.func.isRequired,
  updatePreferences: PropTypes.func.isRequired,
};

export default AgentBio;